const FULL_ALPHABET_RADIX = 36;
const PAST_POINT_CHARACTER_INDEX = 2;
const ID_LENGTH = 8;
const DELIMITER = '--';

export function createRandomId(prefix = '', postfix = ''): string {
  const randomString = Math.random()
    .toString(FULL_ALPHABET_RADIX)
    .slice(PAST_POINT_CHARACTER_INDEX, ID_LENGTH);

  return [prefix, randomString, postfix].filter(Boolean).join(DELIMITER);
}
